// LogLevel codes based on Nop

export const LEVEL_DEBUG = 10;
export const LEVEL_INFORMATION = 20;
export const LEVEL_WARNING = 30;
export const LEVEL_ERROR = 40;
export const LEVEL_FATAL = 50;
